import {ictAxios as axios} from "@plm/o10-share-front";
import { instance } from '@posco/posco-shared';
class O10g015460Repository {

  @instance
  static instance;

  apiUrl5462 = '/o10rq0-readonly/o10g015462';
  apiUrl5350 = '/o10g01-invcommon/o10g015350';
  apiUrlExternalLogin = '/o10g01-invcommon/externalLogin';
  apiUrlLogin = '/o10g01-invcommon/login';
  apiUrl = '/o10g01-invcommon/o10g015370';

  /**외부사용자**/
  saveExternalUserAuthority(params) {
    return axios.post(this.apiUrl5350, params)
      .then(response => response && response.data);
  }

  onFindVersion() {
    return axios.get(`${this.apiUrl5462}/findVersion`)
      .then(response => response && response.data);
  }

  onFindExpl(version) {
    return axios.get(`${this.apiUrl5462}/findExpl/${version}`)
      .then(response => response && response.data);
  }

  onFindId(rows) {
    return axios.post(`${this.apiUrlExternalLogin}/findId`, rows)
      .then(response => response.data);
  }

  onFindPW(rows) {
    return axios.post(`${this.apiUrlExternalLogin}/findPassWord`, rows)
      .then(response => response.data);
  }

  onDuplicateId(id) {
    return axios.post(`${this.apiUrl5462}/duplicateId`, id)
      .then(response => response.data);
  }

  onDupFamilyId(id) {
    return axios.post(`${this.apiUrl5462}/dupFamilyId`, id)
      .then(response => response.data);
  }

  onDuplicateEmail(email) {
    return axios.post(`${this.apiUrl5462}/duplicateEmail`, email)
      .then(response => response.data);
  }

  /**회원가입시 개인정보 처리방침**/
  onRetrieveAllUser030s(page, itclearConfirmTp) {
    console.log("page",page);
    console.log("itclearConfirmTp",itclearConfirmTp);
    itclearConfirmTp='Y'
    return axios.get(`${this.apiUrl}/list?page=${page}&itclearConfirmTp=${itclearConfirmTp||''}`)
      .then(response => {
        console.log("user0303003",response);
        return {
          content :response && response.data && response.data.object.content,
          // pageInfo: {
          //   totalElements: response.data.object.totalElements,
          //   totalPages: response.data.object.totalPages,
          //   number: response.data.object.number + 1
          // }
        }});
  }

  /**인증서 연결**/
  loginWithCert(userInfo) {
    const data = {
      id: userInfo.id,
      password: userInfo.password,
      customerNumber: userInfo.customerNumber,
      signature: userInfo.signature,
    };


    return axios.post(`${this.apiUrlLogin}/cert`, data)
      .then(response => response);
  }
}

export default O10g015460Repository;
